
export enum DynamicSettingsButtonType {
    Push = "push",
    Toggle = "toggle"
}